// src/assets/icons/CustomIconsAdd2.js

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// --- NEW TOOLS (Eraser, Import, Download, Upload, Broadcast, Publish) ---

export const MenuEraser = (props) => (
  <SvgIcon {...props} viewBox='0 0 9.525 9.525'>
    <g fill='#fff'>
      <rect x='7.2626' y='8.4419' width='.19002' height='.30879' strokeWidth='0' />
      <g stroke='#000'>
        <ellipse cx='4.7874' cy='4.7762' rx='4.54' ry='4.5589' strokeWidth='.34287' />
        <rect
          transform='matrix(.70518 .70903 -.70518 .70903 0 0)'
          x='4.574'
          y='-2.9144'
          width='4.1544'
          height='5.5018'
          ry='1.2538'
          strokeWidth='.39688'
        />
        <path d='m3.7104 2.729 2.8768 2.919' strokeWidth='.15756' />
      </g>
    </g>
    <path
      d='m4.0732 2.9679-0.21707-0.22622 0.35981-0.36177c0.27801-0.27952 0.38223-0.37517 0.45845-0.42075 0.36558-0.21858 0.84704-0.21857 1.2126 0 0.14602 0.087305 1.4582 1.4066 1.545 1.5534 0.21739 0.36757 0.21739 0.85166 0 1.2192-0.045457 0.07686-0.1412 0.18217-0.42538 0.4679l-0.36673 0.36873-1.1748-1.1872c-0.64615-0.65294-1.2725-1.289-1.3919-1.4134z'
      fill='#a0cbf7'
      stroke='#000'
      strokeWidth='.014145'
    />
    <path
      d='m1.9352 7.0352h4.9604v0.074732'
      fill='#a0cbf7'
      stroke='#000'
      strokeWidth='.39688'
    />
    <rect
      x='1.8275'
      y='7.1324'
      width='5.717'
      height='.66797'
      rx='0'
      ry='0'
      fill='#fff'
      strokeWidth='0'
    />
  </SvgIcon>
);

// --- MODIFIED MENU IMPORT (Configurable) ---
export const MenuImport = ({
  iconScale = 11, // Size of the icon graphic
  iconX = 15, // Horizontal position
  iconY = 5, // Vertical position
  textSize = '18px', // Size of the text
  textY = 108, // Vertical position of text
  label = 'Import', // Text Label
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    {/* Icon Graphic Group */}
    <g transform={`translate(${iconX}, ${iconY}) scale(${iconScale})`}>
      <rect
        x='-.009858'
        y='5.1656'
        width='6.3782'
        height='1.183'
        fillOpacity='0'
        strokeWidth='.18521'
      />
      <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
      <g stroke='#000'>
        <ellipse
          cx='3.1745'
          cy='3.1753'
          rx='3.0364'
          ry='3.049'
          fill='#fff'
          strokeWidth='.22931'
        />
        <path
          d='m0.42066 3.4354 5.4586-0.63099-1.1919 2.6442-2.3938 0.30047z'
          fill='#2aff00'
          strokeWidth='.052917'
        />
        <circle cx='3.1988' cy='2.018' r='1.391' fill='#fff' strokeWidth='.080581' />
        <path
          d='m2.0795 2.8334c0.031112 0.079268 1.1014 1.5182 1.1014 1.5182l1.1449-1.5121'
          fill='#fff'
          strokeWidth='.080436'
        />
      </g>
      <circle cx='3.1988' cy='2.0103' r='1.2703' fill='#ff0f14' strokeWidth='.05774' />
      <circle cx='3.1708' cy='2.0177' r='.62737' strokeWidth='.028518' />
    </g>

    {/* Text Label */}
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- MODIFIED MENU IMPORT GREY (Configurable) ---
export const MenuImportGrey = ({
  iconScale = 11,
  iconX = 15,
  iconY = 5,
  textSize = '18px',
  textY = 108,
  label = 'Import',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform={`translate(${iconX}, ${iconY}) scale(${iconScale})`}>
      <rect
        x='-.009858'
        y='5.1656'
        width='6.3782'
        height='1.183'
        fillOpacity='0'
        strokeWidth='.18521'
      />
      <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
      <g stroke='#000'>
        <ellipse
          cx='3.1745'
          cy='3.1753'
          rx='3.0364'
          ry='3.049'
          fill='#fff'
          strokeWidth='.22931'
        />
        <path
          d='m0.42066 3.4354 5.4586-0.63099-1.1919 2.6442-2.3938 0.30047z'
          fill='#9e9e9e'
          strokeWidth='.052917'
        />
        <circle cx='3.1988' cy='2.018' r='1.391' fill='#fff' strokeWidth='.080581' />
        <path
          d='m2.0795 2.8334c0.031112 0.079268 1.1014 1.5182 1.1014 1.5182l1.1449-1.5121'
          fill='#fff'
          strokeWidth='.080436'
        />
      </g>
      <circle cx='3.1988' cy='2.0103' r='1.2703' fill='#9e9e9e' strokeWidth='.05774' />
      <circle cx='3.1708' cy='2.0177' r='.62737' strokeWidth='.028518' />
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- NEW MENU UPLOAD (Configurable) ---
export const MenuUpload = ({
  iconScale = 8,
  iconX = 12,
  iconY = 5,
  textSize = '18px',
  textY = 108,
  label = 'Upload',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform={`translate(${iconX}, ${iconY}) scale(${iconScale})`}>
      <g fill='#fff'>
        <rect x='7.0072' y='7.886' width='.19002' height='.30879' strokeWidth='0' />
        <ellipse
          cx='4.7584'
          cy='4.8102'
          rx='4.54'
          ry='4.5589'
          stroke='#000'
          strokeWidth='.34287'
        />
        <path
          d='m2.2289 5.5063v2.0614h5.218v-2.0614'
          stroke='#000'
          strokeWidth='.57406'
        />
        <g stroke='#59c94b'>
          <path d='m4.8037 5.8549v-3.9481' strokeWidth='1.1896' />
          <path d='m2.9312 3.3733 2.2098-2.2098' strokeWidth='1.0583' />
          <path d='m6.6483 3.3901-2.2098-2.2098' strokeWidth='1.0583' />
        </g>
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

export const MenuUploadGrey = ({
  iconScale = 8,
  iconX = 12,
  iconY = 5,
  textSize = '18px',
  textY = 108,
  label = 'Upload',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform={`translate(${iconX}, ${iconY}) scale(${iconScale})`}>
      <g fill='#fff'>
        <rect x='7.0072' y='7.886' width='.19002' height='.30879' strokeWidth='0' />
        <ellipse
          cx='4.7584'
          cy='4.8102'
          rx='4.54'
          ry='4.5589'
          stroke='#000'
          strokeWidth='.34287'
        />
        <path
          d='m2.2289 5.5063v2.0614h5.218v-2.0614'
          stroke='#000'
          strokeWidth='.57406'
        />
        <g stroke='#9e9e9e'>
          <path d='m4.8037 5.8549v-3.9481' strokeWidth='1.1896' />
          <path d='m2.9312 3.3733 2.2098-2.2098' strokeWidth='1.0583' />
          <path d='m6.6483 3.3901-2.2098-2.2098' strokeWidth='1.0583' />
        </g>
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- MODIFIED MENU DOWNLOAD (Configurable) ---
export const MenuDownload = ({
  iconScale = 8,
  iconX = 12,
  iconY = 5,
  textSize = '18px',
  textY = 108,
  label = 'Download',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    {/* Scaled Icon Group */}
    <g transform={`translate(${iconX}, ${iconY}) scale(${iconScale})`}>
      <g fill='#fff'>
        <ellipse
          cx='4.7584'
          cy='4.8102'
          rx='4.54'
          ry='4.5589'
          stroke='#000'
          strokeWidth='.34287'
        />
        <path
          d='m2.2289 5.5063v2.0614h5.218v-2.0614'
          stroke='#000'
          strokeWidth='.57406'
        />
        <g transform='rotate(179.72 4.7898 3.3221)' fillOpacity='0' stroke='#0e92ff'>
          <path d='m4.8037 5.8549v-3.9481' strokeWidth='1.1896' />
          <path d='m2.9312 3.3733 2.2098-2.2098' strokeWidth='1.0583' />
          <path d='m6.6483 3.3901-2.2098-2.2098' strokeWidth='1.0583' />
        </g>
      </g>
    </g>

    {/* Text Label */}
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'
      style={{ opacity: props.sx?.opacity || 1 }}>
      {label}
    </text>
  </SvgIcon>
);

// --- AMENDED MENU BROADCAST ICON ---
export const MenuBroadcast = ({
  iconScale = 8,
  iconX = 12,
  iconY = 5,
  textSize = '18px',
  textY = 108,
  label = 'Broadcast',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform={`translate(${iconX}, ${iconY}) scale(${iconScale})`}>
      <ellipse
        cx='4.7584'
        cy='4.8102'
        rx='4.54'
        ry='4.5589'
        fill='#fff'
        stroke='#000'
        strokeWidth='.34287'
      />
      <g
        transform='matrix(.73557 -.88004 1.3124 .99849 -1.892 6.7605)'
        fill='#92d9ff'
        stroke='#000'>
        <rect x='1.8633' y='1.5778' width='5.7834' height='2.373' strokeWidth='.052917' />
        <path d='m1.8774 3.929 1.8174-1.5488' strokeWidth='.053455' />
        <path d='m1.8716 1.5889 2.9619 1.277' strokeWidth='.065781' />
        <path d='m7.6316 1.5975-2.8261 1.2667' strokeWidth='.063996' />
        <path d='m7.6063 3.9354-1.7042-1.55' strokeWidth='.050496' />
      </g>
      <g fill='#1a79ff' stroke='#000'>
        <path d='m0.93146 3.2526h3.2226' strokeWidth='.20486' />
        <path d='m1.3855 2.4307h3.4554' strokeWidth='.21167' />
        <path d='m0.65938 4.0113h2.8551' strokeWidth='.20281' />
        <path d='m0.58092 5.1263h2.0044' strokeWidth='.18429' />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'
      style={{ opacity: props.sx?.opacity || 1 }}>
      {label}
    </text>
  </SvgIcon>
);

// --- NEW MENU PUBLISH ICON ---
export const MenuPublish = ({
  iconScale = 0.7,
  iconX = 50,
  iconY = 45,
  textSize = '18px',
  textY = 108,
  label = 'Publish',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-50, -50)`}>
      <g fill='#2310ea'>
        <path d='m62.148 33.755h5.024l-5.594-5.595v5.025c1e-3 0.315 0.256 0.57 0.57 0.57z' />
        <path d='m42.196 56.721c-5.652 0-10.25 4.598-10.25 10.25s4.598 10.25 10.25 10.25c5.651 0 10.249-4.598 10.249-10.25s-4.597-10.25-10.249-10.25zm5.941 6.788-7.555 7.555c-0.349 0.349-1.021 0.243-1.501-0.237l-2.671-2.671c-0.48-0.479-0.48-1.258 0-1.738s1.258-0.479 1.738 0l1.801 1.802 6.449-6.449c0.35-0.349 1.021-0.243 1.501 0.238 0.481 0.48 0.587 1.151 0.238 1.5z' />
        <path d='m51.412 10.837c-22.092 0-40 17.909-40 40s17.908 40 40 40 40-17.909 40-40-17.908-40-40-40zm-9.216 68.402c-6.766 0-12.27-5.503-12.27-12.268s5.504-12.269 12.27-12.269c6.764 0 12.268 5.504 12.268 12.269s-5.504 12.268-12.268 12.268zm30.702-37.051v30.494c0 1.889-1.532 3.42-3.42 3.42h-13.25v-2.85h13.251c0.314 0 0.569-0.255 0.569-0.57v-36.052l-0.024-0.025h-7.875c-1.888 0-3.42-1.531-3.42-3.42v-7.875l-0.024-0.025h-19.72c-0.314 0-0.569 0.255-0.569 0.57v27.079h-2.851v-27.079c0-1.889 1.532-3.42 3.42-3.42h20.899l13.015 13.014v6.739z' />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'
      style={{ opacity: props.sx?.opacity || 1 }}>
      {label}
    </text>
  </SvgIcon>
);

export const MenuPublishGrey = ({
  iconScale = 0.7,
  iconX = 50,
  iconY = 45,
  textSize = '18px',
  textY = 108,
  label = 'Publish',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-50, -50)`}>
      <g fill='#9e9e9e'>
        <path d='m62.148 33.755h5.024l-5.594-5.595v5.025c1e-3 0.315 0.256 0.57 0.57 0.57z' />
        <path d='m42.196 56.721c-5.652 0-10.25 4.598-10.25 10.25s4.598 10.25 10.25 10.25c5.651 0 10.249-4.598 10.249-10.25s-4.597-10.25-10.249-10.25zm5.941 6.788-7.555 7.555c-0.349 0.349-1.021 0.243-1.501-0.237l-2.671-2.671c-0.48-0.479-0.48-1.258 0-1.738s1.258-0.479 1.738 0l1.801 1.802 6.449-6.449c0.35-0.349 1.021-0.243 1.501 0.238 0.481 0.48 0.587 1.151 0.238 1.5z' />
        <path d='m51.412 10.837c-22.092 0-40 17.909-40 40s17.908 40 40 40 40-17.909 40-40-17.908-40-40-40zm-9.216 68.402c-6.766 0-12.27-5.503-12.27-12.268s5.504-12.269 12.27-12.269c6.764 0 12.268 5.504 12.268 12.269s-5.504 12.268-12.268 12.268zm30.702-37.051v30.494c0 1.889-1.532 3.42-3.42 3.42h-13.25v-2.85h13.251c0.314 0 0.569-0.255 0.569-0.57v-36.052l-0.024-0.025h-7.875c-1.888 0-3.42-1.531-3.42-3.42v-7.875l-0.024-0.025h-19.72c-0.314 0-0.569 0.255-0.569 0.57v27.079h-2.851v-27.079c0-1.889 1.532-3.42 3.42-3.42h20.899l13.015 13.014v6.739z' />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- NEW TARGET ICON ---
export const MenuTarget = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 100'>
    {/* 1. Outer Red Circle */}
    <circle cx='50' cy='50' r='40' fill='#f44336' stroke='none' />

    {/* 2. White Ring */}
    <circle cx='50' cy='50' r='30' fill='#ffffff' stroke='none' />

    {/* 3. Inner Red Circle */}
    <circle cx='50' cy='50' r='20' fill='#f44336' stroke='none' />

    {/* 4. Center White Circle */}
    <circle cx='50' cy='50' r='10' fill='#ffffff' stroke='none' />

    {/* 5. Crosshair (Black lines extending past the outer circle) */}
    {/* Horizontal Line */}
    <line
      x1='2'
      y1='50'
      x2='98'
      y2='50'
      stroke='#000000'
      strokeWidth='4'
      strokeLinecap='round'
    />
    {/* Vertical Line */}
    <line
      x1='50'
      y1='2'
      x2='50'
      y2='98'
      stroke='#000000'
      strokeWidth='4'
      strokeLinecap='round'
    />
  </SvgIcon>
);

export const MenuTargetGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 100'>
    {/* 1. Outer Grey Circle */}
    <circle cx='50' cy='50' r='40' fill='#9e9e9e' stroke='none' />

    {/* 2. White Ring */}
    <circle cx='50' cy='50' r='30' fill='#ffffff' stroke='none' />

    {/* 3. Inner Grey Circle */}
    <circle cx='50' cy='50' r='20' fill='#9e9e9e' stroke='none' />

    {/* 4. Center White Circle */}
    <circle cx='50' cy='50' r='10' fill='#ffffff' stroke='none' />

    {/* 5. Crosshair - Slightly lighter for disabled look */}
    <g stroke='#616161' strokeWidth='4' strokeLinecap='round'>
      <line x1='2' y1='50' x2='98' y2='50' />
      <line x1='50' y1='2' x2='50' y2='98' />
    </g>
  </SvgIcon>
);

// --- MARKER ASSETS (Pins) ---

export const MarkerNew = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 6.35'>
    <rect
      x='-.009858'
      y='5.1656'
      width='6.3782'
      height='1.183'
      fillOpacity='0'
      strokeWidth='.18521'
    />
    <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
    <path
      d='m3.1763-0.9168v7.6301'
      fill='#c3dfcb'
      fillOpacity='.98786'
      stroke='#000'
      strokeWidth='.0026458'
    />
    <g transform='matrix(.66723 0 0 .66723 -.098224 -.013894)'>
      <circle
        cx='4.9526'
        cy='3.5819'
        r='3.4525'
        fill='#fff'
        stroke='#000'
        strokeWidth='.2'
      />
      <path
        d='m2.1746 5.6058c0.07722 0.19674 2.7336 3.7682 2.7336 3.7682l2.8417-3.7531'
        fill='#fff'
        stroke='#000'
        strokeWidth='.19964'
      />
      <circle cx='4.9527' cy='3.5629' r='3.1528' fill='#f32127' strokeWidth='.14331' />
      <circle cx='4.8831' cy='3.5812' r='1.5571' strokeWidth='.070782' />
    </g>
  </SvgIcon>
);

// --- HOME MARKER ---
export const HomeMarker = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 6.35'>
    <rect
      x='-.009858'
      y='5.1656'
      width='6.3782'
      height='1.183'
      fillOpacity='0'
      strokeWidth='.18521'
    />
    <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
    <g transform='matrix(.66592 0 0 .66592 -.089676 -.003558)'>
      <circle
        cx='4.9526'
        cy='3.5819'
        r='3.4525'
        fill='#fff'
        stroke='#000'
        strokeWidth='.2'
      />
      <path
        d='m2.1746 5.6058c0.07722 0.19674 2.7336 3.7682 2.7336 3.7682l2.8417-3.7531'
        fill='#fff'
        stroke='#000'
        strokeWidth='.19964'
      />
      <circle cx='4.9527' cy='3.5629' r='3.1528' fill='#21c9f3' strokeWidth='.14331' />
      <circle cx='4.8831' cy='3.5812' r='1.5571' strokeWidth='.070782' />
    </g>
  </SvgIcon>
);

export const MARKER_NEW_SVG_STRING = `<svg width="24" height="24" version="1.1" viewBox="0 0 6.35 6.35" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><rect x="-.009858" y="5.1656" width="6.3782" height="1.183" fill-opacity="0" stroke-width=".18521"/><path d="m3.1644-0.009858v6.4077" fill-opacity="0" stroke-width=".18521"/><path d="m3.1763-0.9168v7.6301" fill="#c3dfcb" fill-opacity=".98786" stroke="#000" stroke-width=".0026458"/><g transform="matrix(.66723 0 0 .66723 -.098224 -.013894)"><circle cx="4.9526" cy="3.5819" r="3.4525" fill="#fff" stroke="#000" stroke-width=".2"/><path d="m2.1746 5.6058c0.07722 0.19674 2.7336 3.7682 2.7336 3.7682l2.8417-3.7531" fill="#fff" stroke="#000" stroke-width=".19964"/><circle cx="4.9527" cy="3.5629" r="3.1528" fill="#f32127" stroke-width=".14331"/><circle cx="4.8831" cy="3.5812" r="1.5571" stroke-width=".070782"/></g></svg>`;

export const HOME_MARKER_SVG_STRING = `<svg width="24" height="24" version="1.1" viewBox="0 0 6.35 6.35" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><rect x="-.009858" y="5.1656" width="6.3782" height="1.183" fill-opacity="0" stroke-width=".18521"/><path d="m3.1644-0.009858v6.4077" fill-opacity="0" stroke-width=".18521"/><g transform="matrix(.66592 0 0 .66592 -.089676 -.003558)"><circle cx="4.9526" cy="3.5819" r="3.4525" fill="#fff" stroke="#000" stroke-width=".2"/><path d="m2.1746 5.6058c0.07722 0.19674 2.7336 3.7682 2.7336 3.7682l2.8417-3.7531" fill="#fff" stroke="#000" stroke-width=".19964"/><circle cx="4.9527" cy="3.5629" r="3.1528" fill="#21c9f3" stroke-width=".14331"/><circle cx="4.8831" cy="3.5812" r="1.5571" stroke-width=".070782"/></g></svg>`;
